itsoftApp.createModule("formsValidation", ["pageLoad"], function() {
    var module = this;
    var captchaFlag = false;
    
    var libraries = {
        captcha: {
            name: "captcha",
            queue: [],
            started: false,
            loaded: false,
            script: "https://www.google.com/recaptcha/api.js?render=explicit&onload=onRecaptchaLoadCallback&hl=en"
        }
    }

    var initQueue = function (name) {
        if (!libraries[name].loaded) {
            return false;
        }

        var qLen = libraries[name].queue.length;
        if (!qLen) {
            return;
        }

        DEBUG && console.log("[module formsValidation-recaptcha] initQueue function fired, queue.length: " + qLen);

        while (libraries[name].queue.length > 0) {
            // Взять первый элемент массива,
            // и вызвать его. Мы уже знаем, что это функция,
            // поэтому доп. проверка не требуется.
            libraries[name].queue.shift()();
        }
    };

    var loadAndInit = function (name) {
        var f = function () {
            libraries[name].loaded = true;
            initQueue(name);
        };

        if (libraries[name].hasOwnProperty("style")) {
            itsoftApp.loadStyle(libraries[name].style);
        }

        itsoftApp.loadScript(libraries[name].script, function () {
            DEBUG && console.log("[module formsValidation-recaptcha] library loaded, ready to init queue");

            if (libraries[name].hasOwnProperty("scriptMore")) {
                itsoftApp.loadScript(libraries[name].scriptMore, function () {
                    f();
                });
            } else {
                f();
            }
        });
    };

    var addEvent = function (func, name) {
        if (typeof func !== "function") {
            return;
        }

        // Если библиотека ещё не загружена, то добавляем в очередь
        if (!libraries[name].loaded) {

            // Если библиотека ещё не начала грузиться, то загружаем её
            // (причём откладываем загрузку библиотеки до полной загрузки самой страницы).
            if (!libraries[name].started) {
                libraries[name].started = true;
                DEBUG && console.log("%c--[module formsValidation-recaptcha] first function added. delegating loadAndInit to pageLoad module (or firing if page already loaded)", "font-style: italic; color: #999");
                itsoftApp.modules.pageLoad.addEvent(function () {
                    loadAndInit(name);
                });
            }
            libraries[name].queue.push(func);
            DEBUG && console.log("[module formvaludation-recaptcha] function added, count of functions to init now: " + libraries[name].queue.length);

        // Если библиотека уже загружена, то просто вызываем переданную функцию
        } else {
            func();
        }
    };

    var startSetup = function (validationElement) {
        var RECAPTCHA_KEY = "6LdopV4dAAAAAKH75sEddM4tzPc4sOBaeqs4PrX8";
        var form = validationElement.querySelector(".js-form-validate");
        var formCaptcha = form.classList.contains("js-captcha");
        var formCaptchaEls = document.querySelectorAll(".js-captcha-el");
        var formId = form.id;
        // var resultId = form.getAttribute("data-result");
        var popupSuccessId = form.getAttribute("data-success-result-id");
        var popupErrorId = form.getAttribute("data-error-result-id");

        var init = function () {
            var passInput = form.querySelector("[data-pass]");
            var passInputRepeat = form.querySelector("[data-pass-repeat]");
            var allInputs = form.querySelectorAll(".form__input");
            var allFormFlags = form.querySelectorAll(".form__checkbox");
            var inputEventFlag = false;
            var submitFlag = false;
            var inputsChecked = false;
            var validationPassed = true;
            var inputsDate = form.querySelectorAll("input[data-date]");
            var inputsTel = form.querySelectorAll("[data-mask]");
            var inputsNumber = form.querySelector("[data-number]");
            var inputsText = form.querySelectorAll("[data-text]");
            var inputsFile = form.querySelectorAll("[type='file']");
            var dataRelationElement = form.querySelector("[data-relation]");

            if (inputsNumber.length > 0) {
                inputsNumber.addEventListener("keydown", function (evt) {
                    if ((evt.keyCode < 48 || evt.keyCode > 57) && (evt.keyCode < 37 || evt.keyCode > 40) && evt.keyCode !== 8 && evt.keyCode !== 46 && evt.keyCode !== 48 && evt.keyCode !== 57 && evt.keyCode !== 109 && evt.keyCode !== 107 && (evt.keyCode < 96 || evt.keyCode > 105)) {
                        evt.preventDefault();
                    }
                });
            }
            // console.log(inputsText, "inputtext")
            if (inputsText.length > 0) {
                Array.prototype.forEach.call(inputsText, function (input) {
                    input.addEventListener("keydown", function (evt) {
                        if (!(/[-a-zA-Zа-яА-ЯЁё\s]+/i.test(evt.key))) {
                            evt.preventDefault();
                        }
                    });
                });
            }

            if (formCaptcha) {
                var inputToken = form.querySelector(".form__token");
                var inputAction = form.querySelector(".form__action");
            }

            if (dataRelationElement) {
                var relationELementsInput = form.querySelectorAll("input[data-relation]:not([type='radio'])");
                var relationELementsRadio = form.querySelectorAll("input[type='radio'][data-relation]");

                Array.prototype.forEach.call(relationELementsRadio, function (el) {
                    el.addEventListener("change", function (evt) {
                        var switchEl = evt.currentTarget;

                        if (switchEl.checked) {
                            var relationGroup = switchEl.getAttribute("data-relation-group");
                            var relationGroupElements = form.querySelectorAll("[data-relation-group='" + relationGroup + "']:not([type='radio'])");
                            var relationName = switchEl.getAttribute("data-relation");
                            var inputs = form.querySelectorAll("input[data-relation='" + relationName + "']:not([type='radio'])");

                            Array.prototype.forEach.call(relationGroupElements, function (groupEl) {
                                groupEl.required = false;
                            });

                            Array.prototype.forEach.call(inputs, function (input) {
                                input.required = true;
                            });
                        }
                    });
                });
            }

            var popupSuccessResult;
            var popupErrorResult;

            if (popupSuccessId && popupErrorId) {
                popupSuccessResult = document.querySelector(popupSuccessId);
                popupErrorResult = document.querySelector(popupErrorId)
            } else {
                popupSuccessResult = document.querySelector("#popup-success-result");
                popupErrorResult = document.querySelector("#popup-error-result");
            }

            var submitButton = form.querySelector("[type='submit']");

            var addError = function (input) {
                // var errorMessage = input.getAttribute("data-error-message");
                var errorMessage = "Error. Please enter a valid information in the fields above: E-mail, Name";
                var inputWrapper = input.closest(".form__input-wrapper")
                // if (inputWrapper) {
                    var errorContainer = form.querySelector(".form__error-text");
                // }

                if (errorContainer) {
                    errorContainer.classList.add("is-active");
                    errorContainer.textContent = errorMessage;
                }

                input.classList.add("js-error");

                if (input.parentNode.classList.contains("js-success-wrapper")) {
                    input.parentNode.classList.remove("js-success-wrapper");
                }

                input.parentNode.classList.add("js-error-wrapper");
            }

            var removeError = function (input, success) {
                var inputWrapper = input.closest(".form__input-wrapper");

                // if (inputWrapper) {
                    var errorContainer = form.querySelector(".form__error-text");
                // }

                if (errorContainer) {
                    errorContainer.classList.remove("is-active");
                    errorContainer.textContent = "";
                }

                input.classList.remove("js-error");
                input.parentNode.classList.remove("js-error-wrapper");

                if (success) {
                    input.parentNode.classList.add("js-success-wrapper");
                }
            }

            var passValidation = function () {
                if (passInput.value !== passInputRepeat.value) {
                    addError(passInputRepeat);
                    validationPassed = false;
                } else {
                    if (passInputRepeat.classList.contains("js-error")) {
                        removeError(passInputRepeat);
                    }
                }
            }

            var telValidation = function (inputTel) {
                if (inputTel.hasAttribute("required") && !inputTel.hasAttribute("data-complete")) {
                    addError(inputTel);
                    validationPassed = false;
                } else if (inputTel.hasAttribute("required") && inputTel.hasAttribute("data-complete")) {
                    removeError(inputTel);
                }
            }

            var dateValidation = function (inputDate) {
                if (inputDate.hasAttribute("required") && !inputDate.hasAttribute("data-complete")) {
                    addError(inputDate);
                    validationPassed = false;
                } else if (inputDate.hasAttribute("required") && inputDate.hasAttribute("data-complete")) {
                    removeError(inputDate);
                }
            }

            var selectValidation = function (select) {
                var el = select.querySelector(".selected:not([data-display])");

                if (!el) {
                  addError(select);
                  validationPassed = false;
                } else {
                  removeError(select);
                }
            }

            var checkAdditionally = function () {
                if (!form.classList.contains("js-validation-active")) {
                    form.classList.add("js-validation-active");
                }
                validationPassed = true;

                var selectEls = form.querySelectorAll(".nice-select.js-select");

                if (selectEls.length > 0) {
                  Array.prototype.forEach.call(selectEls, function (selectEl) {
                    selectValidation(selectEl);
                  });
                }

                if (passInput && passInputRepeat) {
                    passValidation(passInput, passInputRepeat);
                }

                if (inputsTel.length > 0) {
                    Array.prototype.forEach.call(inputsTel, function (inputTel) {
                        telValidation(inputTel);
                    });
                }

                if (inputsDate.length > 0) {
                    Array.prototype.forEach.call(inputsDate, function (inputDate) {
                        dateValidation(inputDate);
                    });
                }
            }

            var onFormSubmit = function (evt) {
                if (!inputsChecked) {
                    checkAdditionally();
                }

                inputsChecked = false; // возвращаем значение по дефолту, чтобы при следующей проверке также выполнялась checkAdditionally

                if (!validationPassed) {
                    return;
                }

                if (!submitFlag) {
                    submitFlag = true;

                    if (!formCaptcha) {
                        sendRequest(new FormData(form), onHandler);
                    } 
                    else {
                        grecaptcha.ready(function () {
                            grecaptcha.execute(clientId.formId, {action: form.getAttribute("data-name")}).then(function (token) {
                                inputToken.setAttribute("value", token);
                                inputAction.setAttribute("value", form.getAttribute("name"));
                                sendRequest(new FormData(form), onHandler);
                            });
                        });
                    }
                }
            }

            var validateForm = function () {
                var checkInput = function (input) {
                    addError(input);

                    input.setCustomValidity("");
                }

                var onFieldInput = function (evt) {
                    if (evt.target.checkValidity()) {
                        if (evt.target.classList.contains("js-error")) {
                            if (!evt.target.hasAttribute("data-validation")) {
                                removeError(evt.target, true);
                            }

                            if (evt.target.hasAttribute("data-date")) {
                                dateValidation(evt.target);
                            }

                            if (evt.target.hasAttribute("data-mask")) {
                                telValidation(evt.target);
                            }

                            if (evt.target.hasAttribute("data-pass-repeat")) {
                                passValidation();
                            }
                        }
                    };
                }

                var onInputInvalid = function (evt) {
                    if (!form.classList.contains("js-validation-active")) {
                        form.classList.add("js-validation-active");
                    }

                    if (!inputsChecked) {
                        checkAdditionally();
                    }

                    checkInput(evt.target);

                    if (!inputEventFlag) {
                        inputEventFlag = true;

                        if (allInputs.length > 0) {
                            Array.prototype.forEach.call(allInputs, function (input) {
                                input.addEventListener("input", onFieldInput);
                            });
                        }

                        if (allFormFlags.length > 0) {
                            Array.prototype.forEach.call(allFormFlags, function (flag) {
                                flag.addEventListener("change", onFieldInput);
                            });
                        }
                    }
                }

                if (allInputs.length > 0) {
                    Array.prototype.forEach.call(allInputs, function (input) {
                        input.addEventListener("invalid", onInputInvalid);
                    });
                }

                if (allFormFlags.length > 0) {
                    Array.prototype.forEach.call(allFormFlags, function (flag) {
                        flag.addEventListener("invalid", onInputInvalid);
                    });
                }
            }

            var onErrorLoad = function (data) {
                if (popupErrorResult) {
                    popupResultError.dispatchEvent(openEvent);
                }
                submitFlag = false;
            }

            var resetForm = function () {
                var inputsFilled = form.querySelectorAll(".form__input--filled");
                
                form.reset();

                Array.prototype.forEach.call(inputsFilled, function (input) {
                    input.classList.remove("form__input--filled");
                    input.parentNode.classList.remove("js-success-wrapper");
                });
            }

            var onHandler = function (response, status) {
                var openedPopups = document.querySelectorAll(".popup.is-opened");
                var status;
                var parseResponse;

                // parseResponse = JSON.parse(response);

                // if (parseResponse) {
                //     status = parseResponse.status;
                // }

                // if (status === 200 || status === true || status === "true") {
                    resetForm();

                    var parentPopup = form.closest(".popup");

                    if (parentPopup) {
                        parentPopup.dispatchEvent(closeEvent);
                    }

                    if (popupSuccessResult) {
                        popupSuccessResult.dispatchEvent(openEvent);
                    }

                    // if (openedPopups) {
                    //     Array.prototype.forEach.call(openedPopups, function (popup) {
                    //         popup.dispatchEvent(closeEvent);
                    //     });
                    // }

                    submitFlag = false;
                // } else {
                //     if (popupErrorResult) {
                //         popupErrorResult.dispatchEvent(openEvent);
                //     }
                //     submitFlag = false;
                // }
            }

            var sendRequest = function (data, onHandler) {
                var xhr = new XMLHttpRequest();
                var URL = form.getAttribute("action");

                xhr.addEventListener("load", function () {
                    // if (popupResult) {
                    //     if (popupResult.classList.contains("js-success")) {
                    //         popupResult.classList.remove("js-success");
                    //     }

                    //     if (popupResult.classList.contains("js-error")) {
                    //         popupResult.classList.remove("js-error");
                    //     } 
                    // }

                    onHandler(xhr.response, xhr.status);
                });

                xhr.open("POST", URL);
                // xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                xhr.send(data);
            }

            var checkInputsTel = function (inputsTel) {
                Array.prototype.forEach.call(inputsTel, function (inputTel) {
                    Inputmask('+7(999)999-99-99', {
                        showMaskOnHover: false,
                        oncomplete: function () {
                            inputTel.setAttribute("data-complete", true);
                            removeError(inputTel);
                        },
                        onincomplete: function () {
                            if (inputTel.hasAttribute("data-complete")) {
                                inputTel.removeAttribute("data-complete");
                            }
                            if (form.classList.contains("js-validation-active")) {
                                addError(inputTel);
                            }
                        }
                    }).mask(inputTel);
                });
            }

            var checkInputsDate = function (inputsDate) {
                Array.prototype.forEach.call(inputsDate, function (inputDate) {
                    var inputWrapper = inputDate.closest(".form__input-wrapper");

                    var options = {
                        locale: "ru",
                        disableMobile: true,
                        dateFormat: "d.m.Y",
                        appendTo: inputWrapper
                    }

                    var datePicker = flatpickr(inputDate, options);
                });
            }

            if (inputsTel.length > 0) {
                addEvent(function () {
                    checkInputsTel(inputsTel);
                }, "mask");
            }

            if (inputsDate.length > 0) {
                addEvent(function () {
                    checkInputsDate(inputsDate);
                }, "datepicker");
            }

            var onInputFileChange = function (evt) {
                var input = evt.currentTarget;
                var fileWrapper = input.closest(".form__file-wrapper");

                if (fileWrapper) {
                    var formFilename = fileWrapper.querySelector(".form__file-name");
                }

                var files = input.files;

                // if (inputWrapper.classList.contains("is-error")) {
                //     var errorMessage = inputWrapper.querySelector(".form__error-text");
                //     if (errorMessage) {
                //         if (files.length > 0 && errorMessage.classList.contains("filled")) {
                //             errorMessage.parentNode.removeChild(errorMessage);
                //         }
                //     }
                // }
                if (files.length > 0) {
                    formFilename.textContent = files[0].name;
                } else {
                    formFilename.textContent = "";
                }
            }

            if (inputsFile.length > 0) {
                Array.prototype.forEach.call(inputsFile, function (inputFile) {
                    inputFile.addEventListener("change", onInputFileChange);
                });
            }

            validateForm();

            form.onsubmit = function (evt) {
                evt.preventDefault();
                onFormSubmit();
            }
        };

        // addEvent(init);

        if (formCaptcha) {
            captchaFlag = true;
            window.onRecaptchaLoadCallback = function () {
              Array.prototype.forEach.call(formCaptchaEls, function (formCaptchaEl) {
                window.clientId = {};
                window.clientId.formId = grecaptcha.render(formCaptchaEl, {
                    "sitekey": RECAPTCHA_KEY,
                    "badge": "inline",
                    "size": "invisible"
                });
              });
            }
        }

        if (formCaptcha) {
            addEvent(init, "captcha");
        } else {
            init();
        }
    }

    module.callback = startSetup;
});